import React, { useEffect } from 'react';
import { 
    Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Grid 
} from '@mui/material';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IconButton } from '@mui/material';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { 
    storeCreatePositionSchedulingRule, 
    storeUpdatePositionSchedulingRule 
} from '../../../../store/position_scheduling_rules';
import { useResponseHandler } from '../../../../hooks/useResponseHandler';
import { initialValuesRule } from '../formik/formInitialValues';
// import { validationSchemaRule } from '../formik/validationSchema';
// import { AutocompleteField } from '../../../../../components/formFields/AutocompleteField';
import { getOnlyCargosSelectStore } from '../../../../store/cargos/thunks';
import { ConstraintsForm } from '../components/options/ConstraintsForm';
import AutocompleteField from '../../../../components/formFields/autocompleteField';
import { validationSchemaRule } from '../formik/validationSchema';

interface Props {
    open: boolean;
    setOpen: (val: boolean) => void;
    reloadTable: () => void;
    item?: any;
    isViewMode?: boolean; 
}

export const CreateEditRuleModal = ({ open, setOpen, reloadTable, item, isViewMode = false }: Props) => {
    
    const dispatch = useDispatch<any>();
    const { handleResponse, ResponseComponents } = useResponseHandler();
    
    const  { positionForSelect }  = useSelector((state: any) => state.positionSchedulingRules);


    console.log('positionForSelect: ', positionForSelect)

   

    const initialData = item ? {
        positionId: item.position ? { value: item.position.id, label: item.position.name } : item.positionId,
        constraints: item.constraints || {}
    } : initialValuesRule;

    const onSubmit = async (values: any, { setSubmitting }: any) => {
        setSubmitting(true);
        let response;
        
        const cleanConstraints = { ...values.constraints };
        Object.keys(cleanConstraints).forEach(key => {
            if (cleanConstraints[key] === '') {
                cleanConstraints[key] = null;
            }
        });

        // Transform Select value if it's an object from Autocomplete
        const data = {
            ...values,
            positionId: typeof values.positionId === 'object' ? values.positionId.value : values.positionId,
            constraints: cleanConstraints
        };

        if (item?.id) {
            response = await dispatch(storeUpdatePositionSchedulingRule(item.id, data));
            await handleResponse(response, 'actualizar regla', true);
        } else {
            response = await dispatch(storeCreatePositionSchedulingRule(data));
            await handleResponse(response, 'crear regla', true);
        }
        
        setSubmitting(false);
        if (response?.ok) {
            setOpen(false);
            reloadTable();
        }
    };

    return (
        <Dialog 
            open={open} 
            onClose={() => setOpen(false)}
            maxWidth="md"
            fullWidth
            PaperProps={{ 
                sx: { 
                    borderRadius: 3, 
                    boxShadow: '0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.2)' 
                } 
            }}
        >
            <DialogTitle sx={{ m: 1, p: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box sx={{ minWidth: 48, width: 48, height: 48, borderRadius: '50%', backgroundColor: 'rgba(105, 108, 255, 0.16)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <AssignmentOutlinedIcon color="primary" />
                    </Box>
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 700, color: 'text.primary', lineHeight: 1.2 }}>
                            {isViewMode ? 'Ver Regla' : item ? 'Editar Regla' : 'Crear Regla de Programación'}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#32475C99' }}>
                            Configura las restricciones de turnos para un cargo específico.
                        </Typography>
                    </Box>
                </Box>
                <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    sx={{ position: 'absolute', right: 16, top: 20, color: '#32475C99' }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <Formik
                initialValues={initialData}
                validationSchema={validationSchemaRule}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {({ isSubmitting, isValid, dirty }) => (
                    <Form>
                        <DialogContent dividers sx={{ borderTop: '1px solid #32475C1F', borderBottom: '1px solid #32475C1F', p: 4 }}>
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <AutocompleteField
                                        name="positionId" 
                                        label="Cargo a Programar"
                                        options={positionForSelect}
                                        disabled={isViewMode || !!item} // Cannot change position once created
                                        placeholder="Seleccione un cargo"
                                    />
                                </Grid>
                            </Grid>

                            <Box sx={{ mt: 4 }}>
                                <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 2, textTransform: 'uppercase', letterSpacing: 1 }}>
                                    Opciones de Restricción (Constraints)
                                </Typography>
                                <ConstraintsForm isViewMode={isViewMode} />
                            </Box>

                            <Box sx={{ backgroundColor: 'rgba(105, 108, 255, 0.08)', borderRadius: 2, p: 2, display: 'flex', gap: 1.5, alignItems: 'flex-start', mt: 4 }}>
                                <InfoOutlinedIcon color="primary" sx={{ fontSize: 22, flexShrink: 0 }} />
                                <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.5 }}>
                                    {isViewMode 
                                        ? 'Estás en modo solo lectura. No puedes modificar los datos.'
                                        : 'Las reglas configuradas se aplicarán automáticamente al momento de asignar turnos a los empleados de este cargo.'
                                    }
                                </Typography>
                            </Box>
                        </DialogContent>
                        
                        {!isViewMode && (
                            <DialogActions sx={{ p: 3 }}>
                                <Button onClick={() => setOpen(false)} color="inherit" variant="outlined" sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}>
                                    Cancelar
                                </Button>
                                <Button 
                                    type="submit" 
                                    color="primary" 
                                    variant="contained" 
                                    disabled={isSubmitting || (!isValid && !dirty)}
                                    sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600, boxShadow: 'none' }}
                                >
                                    Guardar Regla
                                </Button>
                            </DialogActions>
                        )}
                    </Form>
                )}
            </Formik>
            {ResponseComponents}
        </Dialog>
    );
};
